import { render, staticRenderFns } from "./CardItem.vue?vue&type=template&id=fea10ad0&scoped=true&"
import script from "./CardItem.vue?vue&type=script&lang=ts&"
export * from "./CardItem.vue?vue&type=script&lang=ts&"
import style0 from "./CardItem.vue?vue&type=style&index=0&id=fea10ad0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea10ad0",
  null
  
)

component.options.__file = "CardItem.vue"
export default component.exports